var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100vh","overflow":"hidden"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":"https://englishadmin.jacknum1.top"}})])
}]

export { render, staticRenderFns }